import { app } from '../../../../bootstrap/core';
import { chartLabelComponent } from './chartLabel.component';

app.component('chartLabel', chartLabelComponent);
